import React from 'react';

const TONES = {
  neutral: 'bg-neutral-100 text-neutral-600',
  green: 'bg-emerald-50 text-emerald-700',
  red: 'bg-primary-50 text-primary-700',
  amber: 'bg-amber-50 text-amber-700',
  blue: 'bg-sky-50 text-sky-700',
  violet: 'bg-violet-50 text-violet-700',
  teal: 'bg-teal-50 text-teal-700',
  outline: 'text-neutral-500 ring-1 ring-inset ring-neutral-200',
};

export const Pill: React.FC<{
  tone?: keyof typeof TONES;
  className?: string;
  title?: string;
  children: React.ReactNode;
}> = ({ tone = 'neutral', className = '', title, children }) => (
  <span
    title={title}
    className={`inline-flex h-5 items-center gap-1 whitespace-nowrap rounded-full px-2 text-[11px] font-medium leading-none ${TONES[tone]} ${className}`}
  >
    {children}
  </span>
);

/** Small status dot, e.g. for connected / unsaved states */
export const Dot: React.FC<{ tone?: 'green' | 'red' | 'amber' | 'blue' | 'violet' | 'teal' | 'neutral'; className?: string }> = ({
  tone = 'neutral',
  className = '',
}) => {
  const color = {
    green: 'bg-emerald-500',
    red: 'bg-primary-600',
    amber: 'bg-amber-500',
    blue: 'bg-sky-500',
    violet: 'bg-violet-500',
    teal: 'bg-teal-500',
    neutral: 'bg-neutral-300',
  }[tone];
  return <span className={`inline-block h-1.5 w-1.5 flex-shrink-0 rounded-full ${color} ${className}`} aria-hidden="true" />;
};
